import React from "react";
import Style from "style-it";
import Button from "./../../Components/common/Button";
import CustomDialog from "./../../Components/common/Dialog";
import MenuItem from "./../../Components/common/MenuItem";
import {
  Grid,
  List,
  ListItemIcon,
  ListItemSecondaryAction,
  Divider,
} from "@mui/material";
// import Collapse from '@mui/material/Collapse'
// import ExpandLess from '@mui/icons-material/ExpandLess'
// import ExpandMore from '@mui/icons-material/ExpandMore'
import TextField from "../../Components/common/TextField";
// import { Container, Draggable } from 'react-smooth-dnd'
import DragHandleIcon from "@mui/icons-material/DragHandle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
// import FormGroup from '@mui/material/FormGroup'
// import FormControlLabel from '@mui/material/FormControlLabel'
import { addTemplate, updateTemplate } from "../../Actions/Templates";
import Checkbox from "../../Components/common/Checkbox";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
// import { useResizeColumns } from 'react-table'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { apiFetch } from "../../Utils/apiFetch";
import ReportSensorSelector from "../../Components/common/ReportSensorSelector";

/** Measurement Sensors Detailed — same rpId as FMS reports. */
const MEASUREMENT_SENSORS_DETAILED_RP_ID = 16;

/** Device Activity — fields are tagged with attributes.rpids for Trip/Stop/EH/Eco. */
const DEVICE_ACTIVITY_RP_ID = 19;

/** Valid Device Activity sections only (Trip / Stop / Engine Hours / Eco). */
const DEVICE_ACTIVITY_SECTION_IDS = ["1", "2", "3", "7"];

/** Fallback labels when /api/reports does not include section report names. */
const DEVICE_ACTIVITY_SECTION_LABELS = {
  1: "Trip",
  2: "Stop",
  3: "Engine Hours",
  7: "Eco",
};

const parseFieldRpids = (column) => {
  const raw = column?.attributes?.rpids;
  if (raw == null || raw === "") {
    return [];
  }
  return String(raw)
    .split(",")
    .map((id) => String(id).trim())
    .filter(Boolean);
};

/** Sections a field may appear in — only valid Device Activity ids from attributes.rpids. */
const getAllowedSectionRpids = (column) =>
  parseFieldRpids(column).filter((id) =>
    DEVICE_ACTIVITY_SECTION_IDS.includes(id)
  );

const isValidDeviceActivitySection = (sectionRpid) =>
  DEVICE_ACTIVITY_SECTION_IDS.includes(String(sectionRpid));

const intersectSectionRpids = (enabledIds, allowedIds) => {
  const allowed = new Set((allowedIds || []).map(String));
  return (enabledIds || [])
    .map(String)
    .filter((id) => allowed.has(id) && isValidDeviceActivitySection(id));
};

const formatSectionRpids = (ids) =>
  [...ids]
    .sort((a, b) => Number(a) - Number(b))
    .join(",");

const isDeviceActivityReport = (rpTmplTbl) =>
  Number(rpTmplTbl?.rpId) === DEVICE_ACTIVITY_RP_ID;

const advanceSettingsForm = {
  detail: false,
  groupBy: "device",
};
const advanceSettingsFormFuel = {
  detail: false,
  groupBy: "device",
  fuelSensor1: "fuel",
  fuelSensor2:"fuel"
};

const SENSOR_CATEGORIES = [
  { value: 1, label: "Discrete" },
  { value: 2, label: "Measurement" },
  // { value: 3, label: "Binder" },
  { value: 4, label: "Aggregate" },
  // { value: -1, label: "Decoder" },
];

const SENSOR_ATTRIBUTES_BY_CATEGORY = {
  1: [
    { label: "Ignition", value: "ignition" },
    { label: "Panic Button", value: "panicButton" },
    { label: "External Power", value: "externalPower" },
    { label: "Engine Status", value: "enginStatus" },
    { label: "Car Alarm", value: "carAlarm" },
    { label: "Doors", value: "doors" },
    { label: "Custom Discrete", value: "customDiscrete" },
    { label: "Work Mode", value: "workMode" },
    { label: "Device Power Cut", value: "devicePowerCut" },
    { label: "Digital Input", value: "din" },
    { label: "Digital Output", value: "dout" },
  ],
  2: [
    { label: "Fuel", value: "fuel" },
    { label: "Flow Meter", value: "flowMeter" },
    { label: "Temperature", value: "temperature" },
    { label: "RPM", value: "rpm" },
    { label: "Average Fuel Consumption", value: "averagFuelConsumption" },
    { label: "Instant Fuel Consumption", value: "instantFuelConsumption" },
    { label: "Mileage", value: "mileage" },
    { label: "Board Power", value: "boardPower" },
    { label: "Humidity", value: "humidity" },
    { label: "Counter", value: "counter" },
    { label: "Custom", value: "custom" },
    { label: "Speed", value: "speed" },
    { label: "Weight", value: "weight" },
  ],
  // [-1]: [
  //   { label: "Decimal", value: "decimal" },
  //   { label: "Binary", value: "binary" },
  //   { label: "Hex Decimal", value: "hexDecimal" },
  // ],
  // 3: [
  //   { label: "Disabled", value: "disabled" },
  //   { label: "Parking Start", value: "parking" },
  //   { label: "Ignition Off", value: "ignition" },
  // ],
  4: [
    { label: "Driver Unique ID", value: "driverUniqueId" },
    { label: "Passenger Unique ID", value: "passengerUniqueId" },
    { label: "Bin Unique ID", value: "binUniqueId" },
    { label: "Trailer Unique ID", value: "trailerUniqueId" },
    { label: "Ignition", value: "ignition" },
    { label: "Panic Button", value: "panicButton" },
    { label: "External Power", value: "externalPower" },
    { label: "Engine Status", value: "enginStatus" },
    { label: "Car Alarm", value: "carAlarm" },
    { label: "Doors", value: "doors" },
    { label: "Fuel", value: "fuel" },
    { label: "Temperature", value: "temperature" },
    { label: "RPM", value: "rpm" },
    { label: "Board Power", value: "boardPower" },
    { label: "Mileage", value: "mileage" },
    { label: "Speed", value: "speed" },
    { label: "Counter", value: "counter" },
    { label: "Average Fuel Consumption", value: "averagFuelConsumption" },
    { label: "Instant Fuel Consumption", value: "instantFuelConsumption" },
    { label: "Flow Meter", value: "flowMeter" },
    { label: "Humidity", value: "humidity" },
    { label: "Weight", value: "weight" },
    { label: "Custom", value: "custom" },
  ],
};

const isCustomSensorAttribute = (value) =>
  value === "custom" || value === "customDiscrete";

const isUnitStatusReport = (rpTmplTbl) => rpTmplTbl?.name === "unitStatus";

const getSensorAttributesForCategory = (category) =>
  SENSOR_ATTRIBUTES_BY_CATEGORY[Number(category)] || [];

const normalizeUnitStatusAttributes = (attributes) => {
  if (!attributes || attributes.sensorCategory === undefined) {
    return attributes;
  }
  const normalized = { ...attributes };
  if (
    isCustomSensorAttribute(normalized.sensorAttribute) &&
    normalized.customSensorAttribute
  ) {
    normalized.sensorAttribute = normalized.customSensorAttribute;
  }
  delete normalized.customSensorAttribute;
  if (normalized.sensorCategory !== "" && normalized.sensorCategory != null) {
    normalized.sensorCategory = Number(normalized.sensorCategory);
  }
  return normalized;
};

const prepareUnitStatusAttributesForEdit = (attributes) => {
  if (!attributes || attributes.sensorCategory === undefined) {
    return attributes;
  }
  const attrs = { ...attributes };
  const categoryAttrs = getSensorAttributesForCategory(attrs.sensorCategory);
  const predefinedValues = categoryAttrs.map((item) => item.value);
  if (
    attrs.sensorAttribute &&
    !predefinedValues.includes(attrs.sensorAttribute)
  ) {
    if (categoryAttrs.some((item) => item.value === "customDiscrete")) {
      attrs.customSensorAttribute = attrs.sensorAttribute;
      attrs.sensorAttribute = "customDiscrete";
    } else if (categoryAttrs.some((item) => item.value === "custom")) {
      attrs.customSensorAttribute = attrs.sensorAttribute;
      attrs.sensorAttribute = "custom";
    }
  }
  return attrs;
};
const templateFormat = (data, id) => ({
  id: id ? id : 0,
  attributes: (data && data.attributes) || {},
  description: (data && data.description) || "",
  name: (data && data.name) || "",
  parentId: (data && data.parentId) || 0,
});
const tableFormat = (data, id, rpId) => {
   const attributes = data?.attributes
    ? { ...data.attributes }
    : { ...advanceSettingsForm };

if (
    id === 3 &&
    (!attributes.evaluationSource || attributes.evaluationSource === "")
  ) {
    attributes.evaluationSource = "motion";
  }
if (id === 1) {
  if (!attributes.fuelSensor1||attributes.fuelSensor1==="") {
    attributes.fuelSensor1 = "fuel";
  }
  if (!attributes.fuelSensor2||attributes.fuelSensor2==="") {
    attributes.fuelSensor2 = "fuel";
  }
}
if (Number(id) === MEASUREMENT_SENSORS_DETAILED_RP_ID) {
  if (!Array.isArray(attributes.sensors)) {
    attributes.sensors = [];
  }
}

  return{
    id: 0,
    attributes,
    rpTmplId: rpId || 0,
    // rpTmplId: (data && data.rpTmplId) || 0,
    description: (data && data.description) || "",
    name: (data && data.name) || "",
    label: (data && data.label) || "",
    position: (data && data.position) || 0,
    rpId: id ? id : 0,
  }
};
const tableFormat2 = (data, id, rpId) => ({
  id: 0,
  attributes: (data && data.attributes) || { ...advanceSettingsFormFuel },
  rpTmplId: rpId || 0,
  // rpTmplId: (data && data.rpTmplId) || 0,
  description: (data && data.description) || "",
  name: (data && data.name) || "",
  label: (data && data.label) || "",
  position: (data && data.position) || 0,
  rpId: id ? id : 0,
});
const columnFormat = (data, id) => ({
  id: 0,
  rpTmplTblId: 0,
  rpFieldId: data.id ? data.id : 0,
  name: (data && data.name) || "",
  label: (data && data.label) || "",
  position: (data && data.position) || 0,
  custom: (data && data.custom) || false,
  attributes: (data && data.attributes) || {},
});

export default class ReportGenerator extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      view: 1,
      mode: 1,
      rpTmpl: templateFormat(),
      rpTmplTblWrappers: [],
      reports: [],
      templateError: false,
      allclear: false,
      rpTmplTbl: tableFormat(),
      columns: [],
      allColumns:[],
      selectedColumns: [],
      editColumnModal: false,
      editColumnForm: {
        attributes: {
          width: 1000,
        },
      },
      saveBtnVisible: false,
      isAdvSettingEnable: false,
      visibleBtnNow: false,
      tableLength: false,
      sensorIn: false,
    };
    this.goNext = this.goNext.bind(this);
    this.validateFirstView = this.validateFirstView.bind(this);
    this.openEditColumnModal = this.openEditColumnModal.bind(this);
    this.cancelFieldModal = this.cancelFieldModal.bind(this);
    this.fieldChange = this.fieldChange.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) {
      return;
    }
    if (destination.index === source.index) {
      return;
    }
    const columns = Array.from(this.state.columns);
    const [removed] = columns.splice(source.index, 1);
    if (this.isUnitNameColumn(removed)) {
      return;
    }
    columns.splice(destination.index, 0, removed);
    const reorderedColumns = this.prioritizeUnitNameColumn(columns);
    const selectedColumns = this.state.selectedColumns.map((column) => {
      const updatedIndex = reorderedColumns.findIndex(
        (col) => col?.id === column.rpFieldId
      );
      if (updatedIndex !== -1) {
        return { ...column, position: updatedIndex };
      }
      return column;
    });
  
    this.setState({
      columns: reorderedColumns,
      selectedColumns,
    });
  };

  goNext(value, edit) {
    // if(!edit){
    //   console.log('value =', value)
    //   console.log('edit =', edit)
    // // }
    if (value === 1) {
      if (!this.validateSecondView()) {
        if (edit === 2) {
          let wrapper = [...this.state.rpTmplTblWrappers];
          let rpTmplTblWrappers = [];
          const normalizedCols = this.getNormalizedSelectedColumns();
          wrapper.map((w) => {
            // if (w.rpTmplTbl.rpId === this.state.rpTmplTbl.rpId && w.editing) {
            if (w.editing) {
              delete w.editing;
              rpTmplTblWrappers.push({
                rpTmplTbl: this.getNormalizedRpTmplTbl(),
                rpTmplCols: normalizedCols,
              });
            } else {
              rpTmplTblWrappers.push(w);
            }
          });
          this.setState(
            {
              view: 1,
              mode: 1,
              rpTmplTblWrappers,
              selectedColumns: [],
              columns: [],
              // rpTmplTbl: tableFormat({ rpTmplId: this.state.rpTmpl.id }),
              allclear: true,
            },
            () => {
              this.checkTablesLength();
            }
          );
        } else {
          let rpTmplTbl = this.getNormalizedRpTmplTbl();
          if (edit === 1) {
            rpTmplTbl.rpTmplId = this.state.rpTmpl.id;
          }
          this.setState(
            {
              view: 1,
              mode: 1,
              rpTmplTblWrappers: [
                ...this.state.rpTmplTblWrappers,
                {
                  rpTmplTbl,
                  rpTmplCols: this.getNormalizedSelectedColumns(),
                },
              ],
              selectedColumns: [],
              columns: [],
              // rpTmplTbl: tableFormat(),
              allclear: true,
            },
            () => {
              this.checkTablesLength();
            }
          );
        }
      }
    } else if (value === 2) {
      if (!this.validateFirstView()) {
        // console.log('state =', this.state)
        // this.setState({ rpTmplTblWrappers:[], rpTmplTbl:[] },()=>{this.setState({ view: 2, rpTmplTblWrappers:[] })})
        this.setState({ view: 2 });
      }
    } else if (value === "submit" || value === "update") {
      let method = value === "update" ? "PUT" : "POST";
      let id = value === "update" ? "/" + this.state.rpTmpl.id : "";
      let obj = JSON.parse(JSON.stringify(this.state.rpTmplTblWrappers));
      if (obj) {
        delete obj[0]?.editing;
      }

      this.setState({ allclear: false, visibleBtnNow: false }, () => {
        apiFetch(`/api/report/templates${id}`, {
          method,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            rpTmpl: this.state.rpTmpl,
            rpTmplTblWrappers: [...obj],
          }),
        })
          .then((response) => {
            if (response.ok) {
              response.json().then((template) => {
                if (template.status === "success") {
                  if (method === "POST") {
                    this.props.dispatch(addTemplate(template.data));
                    this.setState({
                      rpTmpl: templateFormat(),
                      rpTmplTblWrappers: [],
                      // allclear: false
                    });

                    this.props.dispatch(notifySuccess("rptmplCreate"));
                  } else {
                    this.props.dispatch(updateTemplate(template.data));
                    this.props.onUpdate();
                    this.setState({
                      rpTmpl: templateFormat(),
                      rpTmplTblWrappers: [],
                      allclear: false,
                    });
                    this.props.dispatch(notifySuccess("rptmplUpdate"));
                  }
                } else if (template?.statusCode === "440") {
                  window.location.replace("/login");
                } else if (template.statusCode) {
                  var err = template?.message.split(":");
                  err[1] = err[1].replace(")", "");
                  this.props.dispatch(notifyError(err[1]));
                }
              });
            } else {
              throw response;
            }
          })
          .catch((e) => {
            this.props.dispatch(notifyError("somethingWentWrong"));
          });
      });
    }
  }
  goBack = () => this.setState({ view: 1 });

  getNormalizedRpTmplTbl = () => {
    const rpTmplTbl = { ...this.state.rpTmplTbl };
    if (isUnitStatusReport(rpTmplTbl)) {
      rpTmplTbl.attributes = normalizeUnitStatusAttributes(
        rpTmplTbl.attributes
      );
    }
    if (Number(rpTmplTbl.rpId) === MEASUREMENT_SENSORS_DETAILED_RP_ID) {
      const attrs = { ...(rpTmplTbl.attributes || {}) };
      attrs.sensors = Array.isArray(attrs.sensors)
        ? attrs.sensors.filter(Boolean)
        : [];
      rpTmplTbl.attributes = attrs;
    }
    return rpTmplTbl;
  };

  getSectionLabelByRpid = (rpid) => {
    const id = String(rpid);
    // Prefer fixed Device Activity section names (Trip/Stop/EH/Eco).
    const fallback = DEVICE_ACTIVITY_SECTION_LABELS[id];
    if (fallback) {
      return this.props.translate(fallback) || fallback;
    }
    const report = (this.state.reports || []).find(
      (r) => String(r.id) === id
    );
    if (report?.name) {
      return this.props.translate(report.name) || report.name;
    }
    return id;
  };

  /**
   * Device Activity: show each field only under sections listed in attributes.rpids
   * (Trip/Stop/EH/Eco). Never under unsupported sections.
   */
  getCategorizedColumns = (columns = this.state.columns) => {
    if (!isDeviceActivityReport(this.state.rpTmplTbl)) {
      return null;
    }
    const list = columns || [];
    const hasRpids = list.some(
      (col) => getAllowedSectionRpids(col).length > 0
    );
    if (!hasRpids) {
      return null;
    }

    // Fixed section order; only include sections that have at least one valid field.
    return DEVICE_ACTIVITY_SECTION_IDS.map((id) => ({
      key: id,
      title: this.getSectionLabelByRpid(id),
      items: list.filter((col) => getAllowedSectionRpids(col).includes(id)),
    })).filter((g) => g.items.length > 0);
  };

  /**
   * Device Activity only: keep enabled-section rpids on selected columns and sync positions.
   * Other report types return selectedColumns unchanged so create/update payloads stay the same.
   */
  getNormalizedSelectedColumns = () => {
    const selected = this.state.selectedColumns || [];
    if (!isDeviceActivityReport(this.state.rpTmplTbl)) {
      return selected;
    }

    const sourceColumns = this.state.allColumns?.length
      ? this.state.allColumns
      : this.state.columns;
    const orderedIds = (this.state.columns || []).map((c) => c.id);

    return selected
      .map((sel) => {
        const source =
          (sourceColumns || []).find((c) => c.id === sel.rpFieldId) ||
          (this.state.columns || []).find((c) => c.id === sel.rpFieldId);
        const positionInOrder = orderedIds.indexOf(sel.rpFieldId);
        const allowed = getAllowedSectionRpids(source || sel);
        // User-enabled sections, clipped to what the field actually supports.
        let enabledIds = intersectSectionRpids(
          parseFieldRpids(sel).length
            ? parseFieldRpids(sel)
            : allowed,
          allowed
        );
        if (this.isUnitNameColumn(source || sel)) {
          enabledIds = [...allowed];
        }
        if (!enabledIds.length) {
          return null;
        }
        const attributes = {
          ...(source?.attributes || {}),
          ...(sel.attributes || {}),
          rpids: formatSectionRpids(enabledIds),
        };
        return {
          ...sel,
          position: positionInOrder >= 0 ? positionInOrder : sel.position,
          attributes,
        };
      })
      .filter(Boolean);
  };

  /** Keep a stable unique field order for Device Activity (used for positions). */
  orderColumnsByRpidCategory = (columns) => {
    if (!columns?.length) {
      return columns || [];
    }
    return this.prioritizeUnitNameColumn(columns);
  };

  handleSensorsChange = (sensors) => {
    this.setState(
      {
        rpTmplTbl: {
          ...this.state.rpTmplTbl,
          attributes: {
            ...this.state.rpTmplTbl.attributes,
            sensors: Array.isArray(sensors) ? sensors.filter(Boolean) : [],
          },
        },
      },
      () => this.validateSecondView()
    );
  };

  validateSecondView() {
    let columnError1 = false;
    if (this.state.rpTmplTbl && !this.state.rpTmplTbl.rpId) {
      columnError1 = true;
    }
    let columnError2 = false;
    if (this.state.rpTmplTbl && !this.state.rpTmplTbl.label) {
      columnError2 = true;
    }

    let columnError3 = false;
    if (this.state.selectedColumns && !this.state.selectedColumns.length) {
      columnError3 = true;
    }

    let columnError4 = false;
    if (isUnitStatusReport(this.state.rpTmplTbl)) {
      const attrs = this.state.rpTmplTbl.attributes || {};
      const hasCategory =
        attrs.sensorCategory !== undefined && attrs.sensorCategory !== "";
      if (hasCategory) {
      //   columnError4 = true;
      // } else {
        const categoryAttributes = getSensorAttributesForCategory(
          attrs.sensorCategory
        );
        if (categoryAttributes.length && !attrs.sensorAttribute) {
          columnError4 = true;
        }
        if (
          isCustomSensorAttribute(attrs.sensorAttribute) &&
          !attrs.customSensorAttribute
        ) {
          columnError4 = true;
        }
      }
    }

    this.setState({ columnError1, columnError2, columnError3, columnError4 });
    return columnError1 || columnError2 || columnError3 || columnError4;
  }

  validateFirstView() {
    let templateError = false;
    if (this.state.rpTmpl && !this.state.rpTmpl.name) {
      templateError = true;
    }
    this.setState({ templateError });
    return templateError;
  }

  templateChange = (name, event) => {
    this.setState(
      {
        rpTmpl: {
          ...this.state.rpTmpl,
          [name]: event.target.value,
        },
      },
      () => this.validateFirstView()
    );
  };

  loadFields = (id, item) => {
    apiFetch("/api/report/fields?reportId=" + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((columns) => {
            if (columns.status === "success") {
              const attrs = item?.rpTmplTbl?.attributes || {};
      const allowedTypes = attrs.detail ? ["all", "detail"] : ["all", "summary"];
      const filterColumns = (list) => {
        return list.filter((col) => {
          const colAttrs = col?.attributes || {};
          const matchesReportType = allowedTypes.includes(colAttrs.reportType);
          if (attrs.evaluationSource === "service") {
            return matchesReportType && (colAttrs.evaluationSource === "service"||colAttrs.evaluationSource === "all");
          }
            if (attrs.evaluationSource === "default") {
            return matchesReportType && (colAttrs.evaluationSource === "default"||colAttrs.evaluationSource === "all");
          }
          return matchesReportType;
        });
      };
              const normalizedApiColumns = columns.data;
              const orderForReport = (cols, rpId) => {
                const prioritized = this.prioritizeUnitNameColumn(cols);
                if (Number(rpId) === DEVICE_ACTIVITY_RP_ID) {
                  return this.orderColumnsByRpidCategory(prioritized);
                }
                return prioritized;
              };
              if (item && item.rpTmplCols && item.rpTmplCols.length) {
                let data = [...normalizedApiColumns];
                let temp1 = item.rpTmplCols;
                let temp2 = data;
                let names = temp1.map((e) => e.name);
                let cols = temp2.filter((e) => !names.includes(e.name));
                let list2 = this.onSort(temp1, cols);
                let list = [];
                list2.map((l) => {
                  let o = temp2.find((d) => d.name === l.name);
                  list.push(o);
                });
const normalizedList = list;
const filteredColumns = orderForReport(
  filterColumns(normalizedList),
  item?.rpTmplTbl?.rpId
);
                const selectedWithUnitName = this.ensureUnitNameSelected(
                  normalizedList,
                  temp1,
                  item?.rpTmplTbl?.id
                );


                this.setState(
                  {
                    selectedColumns: selectedWithUnitName,
                    rpTmplTbl: item.rpTmplTbl,
                    mode: 2,
                    view: 2,
                    allColumns: normalizedList,
                    columns:filteredColumns,
                  },
                  () => this.validateSecondView()
                );
              } else {
const filteredColumns = orderForReport(
  filterColumns(normalizedApiColumns),
  id
);
                const selectedWithUnitName = this.ensureUnitNameSelected(
                  normalizedApiColumns,
                  [],
                  this.state.rpTmplTbl.id
                );

                this.setState({allColumns: normalizedApiColumns, columns: filteredColumns, selectedColumns: selectedWithUnitName}, () =>
                  this.validateSecondView()
                );
              }
            } else if (columns?.statusCode === "440") {
              window.location.replace("/login");
            } else if (columns.statusCode) {
              var err = columns?.message.split(":");
              err[1] = err[1].replace(")", "");
              this.props.dispatch(notifyError(err[1]));
            }
          });
        } else {
          throw response;
        }
      })
      .catch((e) => {
        console.log("e =", e);
        // this.props.dispatch(notifyError({
        //   message: 'somethingWentWrong',
        //   autoDismiss: 5
        // }))
      });
  };
  tableChange = (name, event) => {
    // if(event.target.value===4){
    //   this.setState({sensorIn:true})
    // }
    if (name === "rpId") {
      this.setState(
        {
          selectedColumns: [],
        },
        () => {
          if (this.state.reports && this.state.reports.length) {
            this.state.reports.map((r) => {
              if (r.id === event.target.value) {
                if (event.target.value === 4) {
                  this.setState(
                    {
                      rpTmplTbl: tableFormat2(
                        r,
                        r.id,
                        this.state.rpTmplTbl.rpTmplId
                      ),
                      allColumns:[],
                      columns: [],
                      selectedcolumns: "",
                      sensorIn: true,
                    },
                    () => {
                      this.loadFields(r.id);
                      this.validateSecondView();
                    }
                  );
                } else {
                  this.setState(
                    {
                      rpTmplTbl: tableFormat(
                        r,
                        r.id,
                        this.state.rpTmplTbl.rpTmplId
                      ),
                      allColumns:[],
                      columns: [],
                      selectedcolumns: "",
                    },
                    () => {
                      this.loadFields(r.id);
                      this.validateSecondView();
                    }
                  );
                }
              }
            });
          }
        }
      );
    } else {
      this.setState(
        {
          rpTmplTbl: {
            ...this.state.rpTmplTbl,
            [name]: event.target.value,
          },
        },
        () => {
          this.validateSecondView();
        }
      );
    }
  };
  updateFilteredColumns = () => {
  const { rpTmplTbl, allColumns, selectedColumns } = this.state;
  const detail = rpTmplTbl?.attributes?.detail;
  const evaluationSource = rpTmplTbl?.attributes?.evaluationSource;
  const allowedTypes = detail ? ['all', 'detail'] : ['all', 'summary'];
  let filteredColumns = this.prioritizeUnitNameColumn(allColumns.filter(col => {
    const reportType = col?.attributes?.reportType?.toLowerCase();
    const colEvalSource = col?.attributes?.evaluationSource?.toLowerCase();

    let matches = allowedTypes.includes(reportType);

    if (evaluationSource === 'service') {
      matches = matches && (colEvalSource === 'service'||colEvalSource==="all");
    }
      if (evaluationSource === 'default') {
      matches = matches && (colEvalSource === 'default'||colEvalSource==="all");
    }

    return matches;
  }));

  if (isDeviceActivityReport(rpTmplTbl)) {
    filteredColumns = this.orderColumnsByRpidCategory(filteredColumns);
  }

  const validSelected = selectedColumns.filter(sel =>
    filteredColumns.some(c => c.id === sel.rpFieldId)
  );
  const selectedWithUnitName = this.ensureUnitNameSelected(
    allColumns,
    validSelected,
    this.state.rpTmplTbl.id
  );

  this.setState({
    columns: filteredColumns,
    selectedColumns: selectedWithUnitName
  });
};
componentDidUpdate(prevProps, prevState) {
  const prevDetail = prevState.rpTmplTbl?.attributes?.detail;
  const prevSource = prevState.rpTmplTbl?.attributes?.evaluationSource;
  const { detail, evaluationSource } = this.state.rpTmplTbl?.attributes || {};

  if (prevDetail !== detail || prevSource !== evaluationSource) {
    this.updateFilteredColumns();
  }
}


  advanceFormChange = (event, name) => {
    if (event && event.target) {
      let { attributes } = { ...this.state.rpTmplTbl };
      let value =
        event.target.type === "checkbox"
          ? event.target.checked
          : event.target.value;
      attributes[name || event.target.id] = value;
      this.setState(
        {
          rpTmplTbl: {
            ...this.state.rpTmplTbl,
            attributes: {
              ...this.state.rpTmplTbl.attributes,
              [name]: value,
            },
          },
          // rpTmpl: {
          //       ...this.state.rpTmpl,
          //       attributes: {
          //         ...this.state.rpTmpl.attributes,
          //         allowFields: arr
          //       }
          //     }
        },
        () => {
if (name === 'detail' || name === 'evaluationSource') {
  this.updateFilteredColumns();
}

          this.validateSecondView()
        }
      );
    }
  };

  sensorFormChange = (event, name) => {
    if (!event?.target) {
      return;
    }
    const value = event.target.value;
    let attributes = { ...this.state.rpTmplTbl.attributes };

    if (name === "sensorCategory") {
      attributes = {
        ...attributes,
        sensorCategory: value,
        sensorAttribute: "",
        customSensorAttribute: "",
      };
    } else if (name === "sensorAttribute") {
      attributes = {
        ...attributes,
        sensorAttribute: value,
        customSensorAttribute: "",
      };
    } else {
      attributes = {
        ...attributes,
        customSensorAttribute: value,
      };
    }

    this.setState(
      {
        rpTmplTbl: {
          ...this.state.rpTmplTbl,
          attributes,
        },
      },
      () => this.validateSecondView()
    );
  };

  componentWillMount() {
    apiFetch("/api/reports?userId=" + this.props.logInUser.id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((reports) => {
            if (reports.status === "success") {
              this.setState({ reports: reports.data });
            } else if (reports?.statusCode === "440") {
              window.location.replace("/login");
            } else if (reports.statusCode) {
              var err = reports?.message.split(":");
              err[1] = err[1].replace(")", "");
              this.props.dispatch(notifyError(err[1]));
            }
          });
        } else {
          throw response;
        }
      })
      .catch((e) => {
        console.log("e =", e);
        // this.props.dispatch(notifyError({
        //   message: 'somethingWentWrong',
        //   autoDismiss: 5
        // }))
      });

    if (this.props.mode === "update") {
      this.setDataForUpdate(this.props.item);
    }
  }
  // checkTablesLength =()=>{
  //   if(this.state?.rpTmplTblWrappers?.length>1 && !this.state?.rpTmpl?.active ){
  //     if(this.state?.rpTmplTblWrappers?.length === 1){
  //           this.setState({tableLength:false})
  //       }
  //       else{
  //         this.setState({tableLength:true})
  //       }
  //     }
  //    else{this.setState({tableLength:false})}
  // }
  checkTablesLength = () => {
    if (
      this.state?.rpTmplTblWrappers?.length > 1 &&
      !this.state?.rpTmpl?.active
    ) {
      this.setState({ tableLength: true });
    } else {
      this.setState({ tableLength: false });
    }
  };
  setDataForUpdate = (item) => {
    this.setState(
      {
        rpTmpl: item.rpTmpl,
        rpTmplTblWrappers: item.rpTmplTblWrappers,
        allclear: true,
      },
      () => {
        this.checkTablesLength();
      }
    );
  };

  insertAt = (array, index, element) => {
    array.splice(index, 0, element);
  };

  onSort = (selectedCols, arr) => {
    const result = [...arr];
    selectedCols.map((payload) => {
      let addedIndex = payload.position;

      this.insertAt(result, addedIndex, payload);
    });

    return result;
  };

  onDrop = (dragResult) => {
    let arr = this.state.columns;
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0];
    }
    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd);
    }

    let selectedColumns = [];
    let arr2 = [...this.state.selectedColumns];
    arr2.map((c) => {
      result.map((e, i) => {
        if (c.rpFieldId === e.id) {
          let obj = { ...c, position: i };
          selectedColumns.push(obj);
        }
      });
    });
    this.setState({ columns: result, selectedColumns });
  };

  onDrop2 = (dragResult) => {
    let arr = this.state.rpTmplTblWrappers;
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
      itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
      result.splice(addedIndex, 0, itemToAdd);
    }

    let selectedColumns = [];
    result.map((e, i) => {
      let obj = { ...e, rpTmplTbl: { ...e.rpTmplTbl, position: i } };
      selectedColumns.push(obj);
    });

    this.setState({ rpTmplTblWrappers: selectedColumns });
  };

  selectTableColumn = (item, position, event, sectionRpid) => {
    if (event && event.target) {
      if (this.isUnitNameColumn(item)) {
        return;
      }

      // Device Activity: toggle one section rpid on the same field (Trip/Stop/EH/Eco).
      if (
        isDeviceActivityReport(this.state.rpTmplTbl) &&
        sectionRpid != null &&
        sectionRpid !== ""
      ) {
        const sectionId = String(sectionRpid);
        const allowed = getAllowedSectionRpids(item);
        // Never enable a section the field does not support.
        if (
          !isValidDeviceActivitySection(sectionId) ||
          !allowed.includes(sectionId)
        ) {
          return;
        }
        const checked = event.target.checked === true;
        let selectedColumns = [...this.state.selectedColumns];
        const idx = selectedColumns.findIndex(
          (c) => c.rpFieldId === item.id
        );
        // Legacy selected rows without rpids = enabled for every section the field supports.
        const resolveEnabledIds = (existing) => {
          const ids = parseFieldRpids(existing);
          return intersectSectionRpids(
            ids.length ? ids : allowed,
            allowed
          );
        };

        if (checked) {
          if (idx === -1) {
            const a = columnFormat(item);
            selectedColumns.push({
              ...a,
              position,
              rpTmplTblId: this.state.rpTmplTbl.id || 0,
              attributes: {
                ...a.attributes,
                rpids: sectionId,
              },
            });
          } else {
            const existing = selectedColumns[idx];
            const ids = resolveEnabledIds(existing);
            if (!ids.includes(sectionId)) {
              ids.push(sectionId);
            }
            selectedColumns[idx] = {
              ...existing,
              attributes: {
                ...existing.attributes,
                rpids: formatSectionRpids(ids),
              },
            };
          }
        } else if (idx !== -1) {
          const existing = selectedColumns[idx];
          const ids = resolveEnabledIds(existing).filter(
            (id) => id !== sectionId
          );
          if (!ids.length) {
            selectedColumns.splice(idx, 1);
          } else {
            selectedColumns[idx] = {
              ...existing,
              attributes: {
                ...existing.attributes,
                rpids: formatSectionRpids(ids),
              },
            };
          }
        }

        this.setState({ selectedColumns }, () => this.validateSecondView());
        return;
      }

      if (event.target.checked === true) {
        let a = columnFormat(item);
        let selectedColumns = [...this.state.selectedColumns];
        selectedColumns.push({
          ...a,
          position,
          rpTmplTblId: this.state.rpTmplTbl.id || 0,
        });
        this.setState({ selectedColumns }, () => this.validateSecondView());
      } else {
        let selectedColumns = [];
        this.state.selectedColumns.map((c) => {
          if (c.rpFieldId !== item.id) {
            selectedColumns.push(c);
          }
        });

        this.setState({ selectedColumns }, () => this.validateSecondView());
      }
    }
  };

  cancelFieldModal() {
    this.setState({
      editColumnModal: false,
      // editColumnForm: {}
    });
  }

  openEditColumnModal(item) {
    let selectedItem = this.state.selectedColumns.find(
      (d) => d.rpFieldId === item.id
    );
    this.setState(
      {
        editColumnForm: selectedItem ? selectedItem : item,
        editColumnModal: true,
      },
      () => {
        this.setState({
          editColumnForm: {
            ...this.state.editColumnForm,
            attributes: {
              width:
                selectedItem &&
                selectedItem.attributes &&
                selectedItem.attributes.width
                  ? selectedItem.attributes.width
                  : 1000,
            },
          },
        });
      }
    );
  }

  updateField() {
    let columns = [...this.state.columns];
    let selectedColumns = [...this.state.selectedColumns];
    const nextWidth =
      this.state.editColumnForm &&
      this.state.editColumnForm.attributes &&
      this.state.editColumnForm.attributes.width;
    columns.map((col) => {
      if (col.id === this.state.editColumnForm.id) {
        col.label = this.state.editColumnForm.label;
      }
    });
    selectedColumns.map((col) => {
      if (col.rpFieldId === this.state.editColumnForm.rpFieldId) {
        col.label = this.state.editColumnForm.label;
        // Preserve rpids / other attrs — only update width.
        col.attributes = {
          ...(col.attributes || {}),
          width: nextWidth,
        };
      }
    });

    this.setState({
      columns,
      selectedColumns,
      editColumnModal: false,
      editColumnForm: {},
    });
  }

  fieldChange(name, event) {
    if (name === "width") {
      this.setState(
        {
          editColumnForm: {
            ...this.state.editColumnForm,
            attributes: {
              ...this.state.editColumnForm.attributes,
              [name]: parseInt(event.target.value),
            },
          },
        },
        () => {
          this.checkRequiredRptCols();
        }
      );
    } else {
      this.setState({
        editColumnForm: {
          ...this.state.editColumnForm,
          [name]: event.target.value,
        },
      });
    }
  }

  checkRequiredRptCols = () => {
    let valid = true;
    let { editColumnForm } = this.state;
    if (
      editColumnForm &&
      editColumnForm.attributes &&
      editColumnForm.attributes.width > 999
    ) {
      this.setState({
        saveBtnVisible: true,
      });
    } else {
      this.setState({
        saveBtnVisible: false,
      });
    }
  };
  deleteTable(index) {
    if (window.confirm("Are you sure you want to delete?")) {
      let rpTmplTblWrappers = [...this.state.rpTmplTblWrappers];
      rpTmplTblWrappers.splice(index, 1);
      this.setState({ rpTmplTblWrappers }, () => {
        this.checkTablesLength();
      });
    }
  }

  editTable(item) {
    // if(item?.rpTmplTbl?.rpId === 4){
    //   this.setState(
    //     {
    //       sensorIn:true,
    //     })
    // }
    item.editing = true;
    let prpObj = JSON.parse(JSON.stringify(item));
    if (prpObj && prpObj.rpTmplTbl && prpObj.rpTmplTbl.attributes) {
      prpObj.rpTmplTbl.attributes = isUnitStatusReport(prpObj.rpTmplTbl)
        ? prepareUnitStatusAttributesForEdit(prpObj.rpTmplTbl.attributes)
        : {
            ...prpObj.rpTmplTbl.attributes,
          };
      if (
        Number(prpObj.rpTmplTbl.rpId) === MEASUREMENT_SENSORS_DETAILED_RP_ID
      ) {
        const attrs = { ...prpObj.rpTmplTbl.attributes };
        if (!Array.isArray(attrs.sensors)) {
          attrs.sensors = [];
        }
        prpObj.rpTmplTbl.attributes = attrs;
      }
    } else {
      prpObj.rpTmplTbl.attributes = JSON.parse(
        JSON.stringify(advanceSettingsForm)
      );
    }
    this.loadFields(item.rpTmplTbl.rpId, prpObj);
  }

  isChecked = (item, sectionRpid) => {
    if (this.isUnitNameColumn(item)) {
      return true;
    }
    const selected = (this.state.selectedColumns || []).find(
      (col) => item?.id === col.rpFieldId
    );
    if (!selected) {
      return false;
    }
    // Device Activity: checked only for allowed + enabled sections.
    if (
      isDeviceActivityReport(this.state.rpTmplTbl) &&
      sectionRpid != null &&
      sectionRpid !== ""
    ) {
      const sectionId = String(sectionRpid);
      const allowed = getAllowedSectionRpids(item);
      if (!allowed.includes(sectionId)) {
        return false;
      }
      const enabled = parseFieldRpids(selected);
      // Legacy rows without rpids → treat as enabled for all allowed sections.
      const ids = intersectSectionRpids(
        enabled.length ? enabled : allowed,
        allowed
      );
      return ids.includes(sectionId);
    }
    return true;
  };

  isUnitNameColumn = (column) => {
    return (column?.label || "").trim().toLowerCase() === "unit name";
  };

  ensureUnitNameSelected = (columns, selectedColumns, rpTmplTblId) => {
    const unitNameColumn = (columns || []).find((column) =>
      this.isUnitNameColumn(column)
    );
    if (!unitNameColumn) {
      return selectedColumns || [];
    }

    const alreadySelected = (selectedColumns || []).some(
      (column) => column.rpFieldId === unitNameColumn.id
    );
    if (alreadySelected) {
      return selectedColumns || [];
    }

    const selected = [...(selectedColumns || [])];
    selected.push({
      ...columnFormat(unitNameColumn),
      position: unitNameColumn.position || 0,
      rpTmplTblId: rpTmplTblId || 0,
    });
    return selected;
  };

  prioritizeUnitNameColumn = (columns) => {
    if (!columns || !columns.length) {
      return columns || [];
    }
    const unitNameColumns = columns.filter((column) =>
      this.isUnitNameColumn(column)
    );
    const otherColumns = columns.filter(
      (column) => !this.isUnitNameColumn(column)
    );
    return [...unitNameColumns, ...otherColumns];
  };

  handleClick = () => {
    this.setState({
      isAdvSettingEnable: !this.state.isAdvSettingEnable,
    });
  };

  handleChange = (event) => {
    const arr = [];
    if (event.target.checked) {
      if (!this.state.rpTmpl.attributes.allowFields) {
        arr.push(event.target.value);
      } else if (this.state.rpTmpl.attributes.allowFields) {
        arr.push(
          ...new Set([
            ...this.state.rpTmpl.attributes.allowFields,
            event.target.value,
          ])
        );
      }
    } else {
      if (this.state.rpTmpl.attributes.allowFields) {
        this.state.rpTmpl.attributes.allowFields.map((r) => {
          if (r !== event.target.value) {
            arr.push(r);
          }
        });
      }
    }

    this.setState({
      rpTmpl: {
        ...this.state.rpTmpl,
        attributes: {
          ...this.state.rpTmpl.attributes,
          allowFields: arr,
        },
      },
    });
  };

  render() {
    const orientation = window.innerWidth <= 1349 ? true : false;
    const { view } = this.state;
    const mandatoryFields = ["driver", "device", "group"];
    let currentFields =
      this.state.rpTmpl &&
      this.state.rpTmpl.attributes &&
      this.state.rpTmpl.attributes.allowFields;
    return (
      <Style>
        {`
            .report-generator {
                background: #fff;
                padding: 10px 20px 20px;
                
            }
            .tab-title{
              margin:0 0 7px
            }
            .text-danger{
              color:red
            }

        `}
        <div>
          <div className="report-generator">
            <h4 className="tab-title">
              {view === 1
                ? this.props.translate("templateName")
                : this.props.translate("templateForm")}
            </h4>
            {view === 1 && (
              <div>
                <Grid container spacing={2}>
                  <Grid item sm={3} xs={12}>
                    <TextField
                      name="name"
                      value={this.state.rpTmpl.name || ""}
                      label={this.props.translate("templateName")}
                      error={this.state.templateError}
                      required
                      onChange={(e) => this.templateChange("name", e)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={9} xs={12}>
                    <TextField
                      name="description"
                      label={this.props.translate("templateDescription")}
                      value={this.state.rpTmpl.description || ""}
                      onChange={(e) => this.templateChange("description", e)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h4 className="tab-title">
                      {this.props.translate("Selection Type")}
                    </h4>
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          "device"
                        )
                      }
                      value="device"
                      onChange={this.handleChange}
                      name="device"
                      label={this.props.translate("device")}
                    />
                    {/* <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'group'
                        )
                      }
                      value='group'
                      onChange={this.handleChange}
                      name='group'
                      label={this.props.translate('group')}
                    /> */}
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          "driver"
                        )
                      }
                      value="driver"
                      onChange={this.handleChange}
                      name="driver"
                      label={this.props.translate("driver")}
                    />
                    {/* <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          "vehicle"
                        )
                      }
                      value="vehicle"
                      onChange={this.handleChange}
                      name="vehicle"
                      label={this.props.translate("vehicle")}
                    /> */}
                    {/* <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'eventType'
                        )
                      }
                      value='eventType'
                      onChange={this.handleChange}
                      name='eventType'
                      label={this.props.translate('reportEventType')}
                    />
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'notification'
                        )
                      }
                      value='notification'
                      onChange={this.handleChange}
                      name='notification'
                      label={this.props.translate('sharedNotification')}
                    />
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'geofence'
                        )
                      }
                      value='geofence'
                      onChange={this.handleChange}
                      name='geofence'
                      label={this.props.translate('sharedGeofence')}
                    />
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'sensor'
                        )
                      }
                      value='sensor'
                      onChange={this.handleChange}
                      name='sensor'
                      label={this.props.translate('sensor')}
                    />
                    <Checkbox
                      checked={
                        this.state.rpTmpl.attributes &&
                        this.state.rpTmpl.attributes.allowFields &&
                        this.state.rpTmpl.attributes.allowFields.includes(
                          'digitalSensor'
                        )
                      }
                      value='digitalSensor'
                      onChange={this.handleChange}
                      name='digitalSensor'
                      label={this.props.translate('digitalSensor')}
                    /> */}
                  </Grid>
                </Grid>
                <p>
                  <Button
                    // disabled={this.state.rpTmpl&&this.state.rpTmpl.attributes&&this.state.rpTmpl.attributes.allowFields ? (this.state.rpTmpl.attributes.allowFields.length ? false : true): true}
                    disabled={!this.state.visibleBtnNow}
                    onClick={(e) => this.goNext(2)}
                  >
                    {this.props.translate("addTable")}
                  </Button>
                </p>
                {this.state.tableLength && (
                  <>
                    <span
                      style={{
                        float: "right",
                        color: "white",
                        background: "rgb(255 0 0 / 70%)",
                        padding: "5px 15px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        "Template with multiple reports need approval from Service Provider"
                      }
                    </span>
                  </>
                )}
                {this.state.rpTmplTblWrappers &&
                this.state.rpTmplTblWrappers.length ? (
                  <h4>{this.props.translate("tablesList")}</h4>
                ) : null}
                <Grid container spacing={2}>
                  <Grid item md={6} xs={12}>
                    <List>
                      <DragDropContext onDragEnd={this.onDragEnd} lockAxis="y">
                        <Droppable droppableId="droppable">
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                            >
                              {this.state.rpTmplTblWrappers.map(
                                (item, index) => (
                                  <Draggable
                                    key={item.rpTmplTbl.rpId}
                                    draggableId={item.rpTmplTbl.rpId}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <MenuItem
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <ListItemIcon className="drag-handle">
                                          <DragHandleIcon />
                                        </ListItemIcon>
                                        {item.rpTmplTbl.label}
                                        <ListItemSecondaryAction>
                                          <ListItemIcon
                                            onClick={() => this.editTable(item)}
                                          >
                                            <EditIcon />
                                          </ListItemIcon>
                                          <ListItemIcon
                                            onClick={() =>
                                              this.deleteTable(index)
                                            }
                                          >
                                            <DeleteIcon />
                                          </ListItemIcon>
                                        </ListItemSecondaryAction>
                                      </MenuItem>
                                    )}
                                  </Draggable>
                                )
                              )}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </List>
                  </Grid>
                </Grid>

                {this.props.mode === "create" && (
                  <Button
                    disabled={!this.state.allclear}
                    onClick={(e) => this.goNext("submit")}
                  >
                    {this.props.translate("sharedCreate")}
                  </Button>
                )}

                {currentFields &&
                currentFields.some(
                  (i) => mandatoryFields && mandatoryFields.includes(i)
                )
                  ? this.setState({ visibleBtnNow: true })
                  : this.setState({ visibleBtnNow: false })}
                {this.props.mode === "update" && (
                  <Button
                    disabled={!this.state.visibleBtnNow}
                    onClick={(e) => this.goNext("update")}
                  >
                    {this.props.translate("update")}
                  </Button>
                )}
              </div>
            )}
            {view === 2 && (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <p>
                      <strong> {this.props.translate("templateName")}:</strong>{" "}
                      {this.state.rpTmpl.name}
                    </p>
                    <strong>
                      {this.props.translate("templateDescription")}:
                    </strong>{" "}
                    {this.state.rpTmpl.description}
                  </Grid>
                </Grid>
                <Divider style={{ margin: "16px 0" }} />
                <Button
                  size="small"
                  style={{ float: "right" }}
                  onClick={(e) => this.goBack()}
                >
                  {this.props.translate("sharedBack")}
                </Button>
                <h4>{this.props.translate("tableForm")}</h4>
                <Grid container spacing={2}>
                  <Grid item sm={3} xs={12}>
                    <TextField
                      name="rpId"
                      label={this.props.translate("selectReport")}
                      value={this.state.rpTmplTbl.rpId}
                      error={this.state.columnError1}
                      required
                      onChange={(e) => this.tableChange("rpId", e)}
                      select
                      fullWidth
                    >
                      {this.state.reports.map((report) => (
                        <MenuItem key={report.id} value={report.id}>
                          {this.props.translate(report.name)}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <TextField
                      name="label"
                      label={this.props.translate("tableLabel")}
                      required
                      value={this.state.rpTmplTbl.label}
                      error={this.state.columnError2}
                      onChange={(e) => this.tableChange("label", e)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={6} xs={12}>
                    <TextField
                      name="description"
                      label={this.props.translate("tableDescription")}
                      value={this.state.rpTmplTbl.description}
                      onChange={(e) => this.tableChange("description", e)}
                      fullWidth
                    />
                  </Grid>
                  <Grid item sm={3} xs={12}>
                    <TextField
                      name="groupBy"
                      label={this.props.translate("groupBy")}
                      value={
                        this.state.rpTmplTbl &&
                        this.state.rpTmplTbl.attributes &&
                        this.state.rpTmplTbl.attributes.groupBy
                      }
                      required
                      onChange={(e) => this.advanceFormChange(e, "groupBy")}
                      select
                      fullWidth
                    >
                      <MenuItem key={"device"} value={"device"}>
                        {this.props.translate("device")}
                      </MenuItem>
                      {this.state.rpTmplTbl.name !== "Stop" &&
                      this.state.rpTmplTbl.name !== "Maintenance" ? (
                        <MenuItem key={"driver"} value={"driver"}>
                          {this.props.translate("driver")}
                        </MenuItem>
                      ) : null}
                      {this.state.rpTmplTbl.name !== "Maintenance" ? (
                        <MenuItem key={"date"} value={"date"}>
                          {this.props.translate("date")}
                        </MenuItem>
                      ) : null}
                    </TextField>
                  </Grid>
                  {isUnitStatusReport(this.state.rpTmplTbl) && (
                    <>
                      <Grid item sm={3} xs={12}>
                        <TextField
                          name="sensorCategory"
                          label={this.props.translate("sensorCategory")}
                          value={
                            this.state.rpTmplTbl?.attributes?.sensorCategory ??
                            ""
                          }
                          error={this.state.columnError4}
                          // required
                          onChange={(e) =>
                            this.sensorFormChange(e, "sensorCategory")
                          }
                          select
                          fullWidth
                        >
                          {SENSOR_CATEGORIES.map((category) => (
                            <MenuItem
                              key={category.value}
                              value={category.value}
                            >
                              {category.label}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {getSensorAttributesForCategory(
                        this.state.rpTmplTbl?.attributes?.sensorCategory
                      ).length > 0 && (
                        <Grid item sm={3} xs={12}>
                          <TextField
                            name="sensorAttribute"
                            label={this.props.translate("sensorAttribute")}
                            value={
                              this.state.rpTmplTbl?.attributes
                                ?.sensorAttribute ?? ""
                            }
                            error={this.state.columnError4}
                            required
                            onChange={(e) =>
                              this.sensorFormChange(e, "sensorAttribute")
                            }
                            select
                            fullWidth
                          >
                            {getSensorAttributesForCategory(
                              this.state.rpTmplTbl?.attributes?.sensorCategory
                            ).map((attribute) => (
                              <MenuItem
                                key={attribute.value}
                                value={attribute.value}
                              >
                                {attribute.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      )}
                      {isCustomSensorAttribute(
                        this.state.rpTmplTbl?.attributes?.sensorAttribute
                      ) && (
                        <Grid item sm={3} xs={12}>
                          <TextField
                            name="customSensorAttribute"
                            label={this.props.translate(
                              "customSensorAttribute"
                            )}
                            value={
                              this.state.rpTmplTbl?.attributes
                                ?.customSensorAttribute ?? ""
                            }
                            error={this.state.columnError4}
                            required
                            onChange={(e) =>
                              this.sensorFormChange(e, "customSensorAttribute")
                            }
                            fullWidth
                          />
                        </Grid>
                      )}
                    </>
                  )}
                  {/* {(this.state.sensorIn ||this.state.rpTmplTbl.attributes?.sensorInput) ? (
                    <Grid item sm={3} xs={12}>
                    <TextField
                      name='sensorInput'
                      label='sensorInput'
                      value={this.state.rpTmplTbl &&
                        this.state.rpTmplTbl.attributes &&
                        this.state.rpTmplTbl.attributes.sensorInput?this.state.rpTmplTbl.attributes.sensorInput:'fuel' }
                      onChange={e => this.advanceFormChange(e, 'sensorInput')}
                      fullWidth
                    />
                  </Grid>): null} */}
                  {(this.state.rpTmplTbl.rpId === 4 ||
                    this.state.rpTmplTbl.rpId === 1 ||
                    this.state.rpTmplTbl.rpId === 14 ||
                    this.state.rpTmplTbl.rpId === 3) && (
                    <Grid item sm={3} xs={12}>
                      <TextField
                        name="fuelSensor1"
                        label={this.props.translate("fuelSensor1")}
                        value={
                          this.state.rpTmplTbl &&
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.fuelSensor1
                            ? this.state.rpTmplTbl.attributes.fuelSensor1
                            : "fuel"
                        }
                        onChange={(e) =>
                          this.advanceFormChange(e, "fuelSensor1")
                        }
                        fullWidth
                      />
                    </Grid>
                  )}
                  {(this.state.rpTmplTbl.rpId === 1 ||
                    this.state.rpTmplTbl.rpId === 14) && (
                    <Grid item sm={3} xs={12}>
                      <TextField
                        name="fuelSensor2"
                        label={this.props.translate("fuelSensor2")}
                        value={
                          this.state.rpTmplTbl &&
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.fuelSensor2
                            ? this.state.rpTmplTbl.attributes.fuelSensor2
                            : "fuel"
                        }
                        onChange={(e) =>
                          this.advanceFormChange(e, "fuelSensor2")
                        }
                        fullWidth
                      />
                    </Grid>
                  )}
                  {/* {this.state.rpTmplTbl.rpId === 1 &&(
                    <Grid item sm={3} xs={12}>
                    <TextField
                      name='sensorInput2'
                      label={this.props.translate('sensorInput2')}
                      value={this.state.rpTmplTbl &&
                        this.state.rpTmplTbl.attributes &&
                        this.state.rpTmplTbl.attributes.sensorInput2?this.state.rpTmplTbl.attributes.sensorInput2:''}
                      onChange={e => this.advanceFormChange(e, 'sensorInput2')}
                      fullWidth
                    />
                  </Grid>)} */}
                  {this.state.rpTmplTbl.rpId === 3 && (
                    <Grid item sm={3} xs={12}>
                      <TextField
                        name="sensorInput"
                        label={this.props.translate("sensorInput")}
                        value={
                          this.state.rpTmplTbl &&
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.evaluationSource
                            ? this.state.rpTmplTbl.attributes.evaluationSource
                            : "workMode"
                        }
                        required
                        onChange={(e) =>
                          this.advanceFormChange(e, "evaluationSource")
                        }
                        select
                        fullWidth
                      >
                        <MenuItem key={"motion"} value={"motion"}>
                          {this.props.translate("motion")}
                        </MenuItem>
                        <MenuItem key={"workMode"} value={"workMode"}>
                          {this.props.translate("work")}
                        </MenuItem>
                      </TextField>
                    </Grid>
                  )}
                    {this.state.rpTmplTbl.rpId === 4 && (
                    <Grid item sm={3} xs={12}>
                      <TextField
                        name="evaluation"
                        label={this.props.translate("evaluation")}
                        value={
                          this.state.rpTmplTbl &&
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.evaluationSource
                            ? this.state.rpTmplTbl.attributes.evaluationSource
                            : "default"
                        }
                        required
                        onChange={(e) =>
                          this.advanceFormChange(e, "evaluationSource")
                        }
                        select
                        fullWidth
                      >
                        <MenuItem key={"default"} value={"default"}>
                          {this.props.translate("default")}
                        </MenuItem>
                        <MenuItem key={"service"} value={"service"}>
                          {this.props.translate("service")}
                        </MenuItem>
                      </TextField>
                    </Grid>
                  )}
                  <Grid item sm={3} xs={12}>
                    {this.state.rpTmplTbl &&
                    this.state.rpTmplTbl.name === "Event" ? (
                      <>
                        <Checkbox
                          checked={
                            this.state.rpTmpl.attributes &&
                            this.state.rpTmpl.attributes.allowFields &&
                            this.state.rpTmpl.attributes.allowFields.includes(
                              "eventType"
                            )
                          }
                          value="eventType"
                          onChange={this.handleChange}
                          name="eventType"
                          label={this.props.translate("reportEventType")}
                        />
                        <Checkbox
                          checked={
                            this.state.rpTmpl.attributes &&
                            this.state.rpTmpl.attributes.allowFields &&
                            this.state.rpTmpl.attributes.allowFields.includes(
                              "notification"
                            )
                          }
                          value="notification"
                          onChange={this.handleChange}
                          name="notification"
                          label={this.props.translate("sharedNotification")}
                        />
                      </>
                    ) : this.state.rpTmplTbl &&
                      this.state.rpTmplTbl.name === "Geofence" ? (
                      <>
                        <Checkbox
                          checked={
                            this.state.rpTmpl.attributes &&
                            this.state.rpTmpl.attributes.allowFields &&
                            this.state.rpTmpl.attributes.allowFields.includes(
                              "geofence"
                            )
                          }
                          value="geofence"
                          onChange={this.handleChange}
                          name="geofence"
                          label={this.props.translate("sharedGeofence")}
                        />
                      </>
                    ) : this.state.rpTmplTbl &&
                      this.state.rpTmplTbl.name === "SensorTracing" ? (
                      <>
                        <Checkbox
                          checked={
                            this.state.rpTmpl.attributes &&
                            this.state.rpTmpl.attributes.allowFields &&
                            this.state.rpTmpl.attributes.allowFields.includes(
                              "sensor"
                            )
                          }
                          value="sensor"
                          onChange={this.handleChange}
                          name="sensor"
                          label={this.props.translate("sensor")}
                        />
                      </>
                    ) : this.state.rpTmplTbl &&
                      this.state.rpTmplTbl.name === "Digital Sensor" ? (
                      <>
                        {" "}
                        <Checkbox
                          checked={
                            this.state.rpTmpl.attributes &&
                            this.state.rpTmpl.attributes.allowFields &&
                            this.state.rpTmpl.attributes.allowFields.includes(
                              "digitalSensor"
                            )
                          }
                          value="digitalSensor"
                          onChange={this.handleChange}
                          name="digitalSensor"
                          label={this.props.translate("digitalSensor")}
                        />
                      </>
                    ) : this.state.rpTmplTbl &&
                      this.state.rpTmplTbl.rpId ===
                        MEASUREMENT_SENSORS_DETAILED_RP_ID ? (
                      <Checkbox
                        id="sensorGraph"
                        onChange={(e) =>
                          this.advanceFormChange(e, "sensorGraph")
                        }
                        checked={
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.sensorGraph
                        }
                        label={this.props.translate("graph")}
                      />
                    ) : null}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    style={{ marginLeft: 5 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap:"0.5rem"
                        // justifyContent: "",
                      }}
                    >
                      <Checkbox
                        id="detail"
                        onChange={(e) => this.advanceFormChange(e, "detail")}
                        checked={
                          this.state.rpTmplTbl.attributes &&
                          this.state.rpTmplTbl.attributes.detail
                        }
                        label={this.props.translate("detailReport")}
                      />
                      <Tooltip
                        classes={{
                          popper: "menu-popper",
                          tooltip: "menu-popper-tooltip",
                        }}
                        title={this.props.translate("DetailsTooltip")}
                      >
                        <HelpOutlineIcon
                          style={{
                            color: "#00C179",
                            fontSize: 15,
                            marginTop: 12,
                            marginRight: 15,
                          }}
                        />
                      </Tooltip>
                    </div>
                  </Grid>
                </Grid>
                {this.state.rpTmplTbl &&
                  this.state.rpTmplTbl.rpId ===
                    MEASUREMENT_SENSORS_DETAILED_RP_ID && (
                    <Grid container spacing={2} style={{ marginTop: 8 }}>
                      <Grid item xs={12} sm={8} md={6}>
                        <ReportSensorSelector
                          value={
                            this.state.rpTmplTbl.attributes &&
                            this.state.rpTmplTbl.attributes.sensors
                          }
                          onChange={this.handleSensorsChange}
                          translate={this.props.translate}
                        />
                      </Grid>
                    </Grid>
                  )}
                {this.state.columns &&
                this.state.columns.length &&
                this.state.columnError3 ? (
                  <p className="text-danger">
                    {this.props.translate(
                      "pleaseSelectAtleaseOneColumnFromAboveList"
                    )}
                  </p>
                ) : null}
                {this.state &&
                this.state.columns &&
                this.state.columns.length ? (
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <List className="table-fields-list">
                        {(() => {
                          const categorized = this.getCategorizedColumns();

                          // Device Activity: fields repeat per section — no DnD (duplicate ids).
                          if (categorized) {
                            return categorized.map((group) => (
                              <div key={group.key}>
                                <p style={headingStyle}>{group.title}</p>
                                {group.items.map((item) => {
                                  const index = this.state.columns.findIndex(
                                    (c) => c?.id === item?.id
                                  );
                                  const checked =
                                    this.isChecked(item, group.key) || false;
                                  return (
                                    <div key={`${group.key}-${item?.id}`}>
                                      <MenuItem selected={checked}>
                                        <ListItemIcon
                                          style={{ marginRight: 0 }}
                                        >
                                          <Checkbox
                                            checked={checked}
                                            disabled={this.isUnitNameColumn(
                                              item
                                            )}
                                            onChange={(e) =>
                                              this.selectTableColumn(
                                                item,
                                                index >= 0 ? index : 0,
                                                e,
                                                group.key
                                              )
                                            }
                                          />
                                        </ListItemIcon>
                                        {item?.label}
                                        {item?.description ? (
                                          <span
                                            style={{
                                              color: "#999",
                                              marginLeft: 10,
                                            }}
                                          >
                                            ({item?.description})
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                        <ListItemSecondaryAction
                                          onClick={() =>
                                            this.openEditColumnModal(item)
                                          }
                                        >
                                          <ListItemIcon>
                                            <EditIcon />
                                          </ListItemIcon>
                                        </ListItemSecondaryAction>
                                      </MenuItem>
                                    </div>
                                  );
                                })}
                              </div>
                            ));
                          }

                          // All other reports: keep existing drag-and-drop list.
                          return (
                            <DragDropContext
                              onDragEnd={this.onDragEnd}
                              lockAxis="y"
                            >
                              <Droppable droppableId="droppable" type="ITEM">
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                  >
                                    {this.state.columns.map((item, index) => (
                                      <Draggable
                                        key={item?.id}
                                        draggableId={String(item?.id)}
                                        index={index}
                                        isDragDisabled={this.isUnitNameColumn(
                                          item
                                        )}
                                      >
                                        {(dragProvided) => (
                                          <div ref={dragProvided.innerRef}>
                                            <MenuItem
                                              {...dragProvided.draggableProps}
                                              {...dragProvided.dragHandleProps}
                                              selected={
                                                this.isChecked(item) || false
                                              }
                                            >
                                              <ListItemIcon className="drag-handle">
                                                <DragHandleIcon />
                                              </ListItemIcon>
                                              <ListItemIcon
                                                style={{ marginRight: 0 }}
                                              >
                                                <Checkbox
                                                  checked={
                                                    this.isChecked(item) ||
                                                    false
                                                  }
                                                  disabled={this.isUnitNameColumn(
                                                    item
                                                  )}
                                                  onChange={(e) =>
                                                    this.selectTableColumn(
                                                      item,
                                                      index,
                                                      e
                                                    )
                                                  }
                                                />
                                              </ListItemIcon>
                                              {item?.label}
                                              {item?.description ? (
                                                <span
                                                  style={{
                                                    color: "#999",
                                                    marginLeft: 10,
                                                  }}
                                                >
                                                  ({item?.description})
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                              <ListItemSecondaryAction
                                                onClick={() =>
                                                  this.openEditColumnModal(
                                                    item
                                                  )
                                                }
                                              >
                                                <ListItemIcon>
                                                  <EditIcon />
                                                </ListItemIcon>
                                              </ListItemSecondaryAction>
                                            </MenuItem>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                    {provided.placeholder}
                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>
                          );
                        })()}
                      </List>
                    </Grid>
                  </Grid>
                ) : null}
                <Button onClick={(e) => this.goNext(1, this.state.mode)}>
                  {this.props.translate("next")}
                </Button>
              </div>
            )}
            {this.state.editColumnModal && (
              <CustomDialog
                title={this.props.translate("modifyLabel")}
                bodyPadding={20}
                hideDragIcon
                isVisableBtn
                fullWidth
                headerActions={
                  <Button
                    disabled={!this.state.saveBtnVisible}
                    onClick={this.updateField}
                  >
                    Save
                  </Button>
                }
                onClose={this.cancelFieldModal}
              >
                <TextField
                  name="label"
                  label={this.props.translate("label")}
                  required
                  value={
                    this.state.editColumnForm && this.state.editColumnForm.label
                  }
                  onChange={(e) => this.fieldChange("label", e)}
                  fullWidth
                />
                <TextField
                  name="label"
                  label={this.props.translate("columnWidth")}
                  required
                  value={
                    this.state.editColumnForm &&
                    this.state.editColumnForm.attributes &&
                    this.state.editColumnForm.attributes.width
                  }
                  onChange={(e) => this.fieldChange("width", e)}
                  fullWidth
                  type="number"
                  error={
                    this.state.editColumnForm &&
                    this.state.editColumnForm.attributes &&
                    this.state.editColumnForm.attributes.width > 999
                      ? false
                      : true
                  }
                  helperText="Enter Value greater than 999"
                />
              </CustomDialog>
            )}
          </div>
        </div>
      </Style>
    );
  }
}

const headingStyle = {
  fontSize: 14,
  padding: 0,
  margin: "10px 0 5px",
  fontWeight: 700,
  textTransform: "capitalize",
  color: "rgba(0, 0, 0, 0.54)",
  cursor: "pointer",
};
